// src/store.ts
import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "../features/modelSlice";
import loginReducer from "../features/loginSlice";
import styleReducer from "../features/styleSlice";

const store = configureStore({
  reducer: {
    modal: modalReducer,
    login: loginReducer,
    style: styleReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
